var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncompleteFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#54585A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 2.182a10 10 0 0 1 3.8 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 21.818a10 10 0 0 1-3.8 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.609 3.721a10 10 0 0 1 2.69 2.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.182 13.9a10 10 0 0 1 0-3.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.279 17.609a10 10 0 0 1-2.7 2.69"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.818 10.1a10 10 0 0 1 0 3.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.721 6.391a10 10 0 0 1 2.7-2.69"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.391 20.279a10 10 0 0 1-2.69-2.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteFolder);
export default __webpack_public_path__ + "static/media/incomplete_folder.0f83bf66213a37344c0077368e966ae3.svg";
export { ForwardRef as ReactComponent };